export type DownloadOptions =
  | {
      source: string;
      fileName: string;
      type: 'url';
    }
  | {
      source: string;
      fileName: string;
      type: 'text';
    }
  | {
      source: Blob;
      fileName: string;
      type: 'image';
    }
  | {
      source: Blob;
      fileName: string;
      type: 'zip';
    };

/**
 * Downloads a file from the specified source with the specified file name and type.
 *
 * @param {DownloadOptions} options - The options for downloading the file.
 * @param {string|Blob} options.source - The source of the file. This is the discriminator for the options.type.
 * @param {string} options.fileName - The name of the file
 * @param {'url'|'text'|'image'|'zip'} optionts.type - The type of the file to download. This is the discriminator for the options.source type.
 *
 * @throws {Error} If the file type or source is invalid.
 */
export function downloadFile(options: DownloadOptions): void {
  const anchor = document.createElement('a');
  anchor.style.display = 'none';

  switch (options.type) {
    case 'url':
      anchor.href = options.source;
      break;
    case 'text':
      anchor.href = 'data:text/plain;charset=utf-8,' + encodeURIComponent(options.source);
      break;
    case 'image':
    case 'zip':
      anchor.href = URL.createObjectURL(options.source);
      break;
    default:
      throw new Error('Invalid file type');
  }

  anchor.download = options.fileName;
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
}
